<div id="notLoggedIn">
    <router-outlet></router-outlet>
</div>